import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { UserContext } from '../utils/contexts';
import newLayerImg from '../assets/images/New_Layer.png';
import graphImg from '../assets/images/graph.png';
import inviteImg from '../assets/images/Vector.png';
import stockImg from '../assets/images/stock.png';
import cutcircleImg from '../assets/images/cutcircle.png';
import connecterImg from '../assets/images/connecter.png';
import halfcircleImg from '../assets/images/halfcircle.png';
import circleImg from '../assets/images/circle.png';
import tickImg from '../assets/images/tick.png';
import containerImg from '../assets/icons/Container.png';
import Button from '../shared/Button';
import { editorURL } from '../utils/editor';
import Charts from '../shared/Charts';
import AppLoader from '../shared/AppLoader';
import Error from '../shared/Error';
import '../assets/styles/Summary.scss';
import '../assets/styles/_install.scss';
import '../assets/styles/_reveal.scss';
import '../assets/styles/_icons.scss';
import '../assets/styles/_charts.scss';
import useFetch from '../utils/useFetch';
import SummaryToolbar, { defaultDateRange } from './SummaryToolbar';
import { withTracking } from '../shared/Tracking';
import SiteLink from '../shared/SiteLink';
import InviteUserDialog from "./Modals/InviteUserDialog";
import andrewImg from '../assets/images/AndrewCattarin.png';
import HelpDialog from '../shared/HelpDialog';

const stastics = [
  { type: 'total', text: 'VIEWS', icon: 'views', chart: 'views' },
  { type: 'call', text: 'CALLS', icon: 'call', chart: 'call' },
  {
    type: 'email',
    text: 'EMAILS COLLECTED',
    icon: 'contacts',
    chart: 'contacts',
  },
  { type: 'traffic', text: 'CLICKS', icon: 'clicks', chart: 'clicks' },
  {
    type: 'social',
    text: 'SOCIAL CONVERSIONS',
    icon: 'social',
    chart: 'social',
  },
];

const Summary = ({ site }) => {
  const [dateRange, setDateRange] = useState(defaultDateRange());
  const [currentSeries, setCurrentSeries] = useState(['total']);
  const [reload, setReload] = useState(false);
  const {
    loading,
    error,
    status,
    data: { numbers, graphs },
  } = useFetch('summary', dateRange.from, dateRange.to, reload);
  const [accordionStates, setAccordionStates] = useState({
    first: true,
    second: false
  });
  const [helpDialogOpen, setHelpDialogOpen] = useState(false);

  // if (sessionStorage.getItem('preselected_plan')) {
  //   const plan = sessionStorage.getItem('preselected_plan');
  //   const upgradeUrl = generatePath("/sites/:id/upgrade/:plan", { id: site.id, plan });
  //   return (<Redirect to={upgradeUrl}/>);
  // }

  const updateChart = (type) => () => {
    setCurrentSeries((prevValue) => {
      if (prevValue.length === 1 && prevValue.includes(type)) {
        return ['total'];
      } else if (prevValue.includes(type)) {
        return prevValue.filter((value) => value !== type);
      } else {
        return [...prevValue, type];
      }
    });
  };

  const setRange = (range) => {
    setDateRange(range);
  };

  const toggleAccordion = (key) => {
    setAccordionStates(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // Helper function to capitalize first letter
  const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  return (
    <UserContext.Consumer>
      {(user) => (
        <div style={{ 
          backgroundColor: '#F2F1F1',
          minHeight: '10vh',
          padding: '20px'
        }}>
          <HelpDialog 
            isOpen={helpDialogOpen} 
            showIcon={false}
            onClose={() => setHelpDialogOpen(false)}
            showButton={false}
          />
          <style>
            {`
              /* Base style for all chart blocks - white background */
              .chart-wrapper .chart-block {
                background-color: white !important;
              }
              
              /* Preserve the specific border colors for each type */
              .chart-wrapper .chart-block.views {
                background-color: white !important;
                /* Border color stays as is */
              }
              
              .chart-wrapper .chart-block.contacts {
                background-color: white !important;
                /* Border color stays as is */
              }
              
              .chart-wrapper .chart-block.clicks {
                background-color: white !important;
                /* Border color stays as is */
              }
              
              .chart-wrapper .chart-block.social {
                background-color: white !important;
                /* Border color stays as is */
              }
              
              .chart-wrapper .chart-block.feedback, 
              .chart-wrapper .chart-block.call {
                background-color: white !important;
                /* Border color stays as is */
              }
              
              /* Also handle activated state */
              .chart-wrapper .chart-block.activated {
                background-color: white !important;
                /* Border color will still change based on type */
              }
            `}
          </style>
          {/* Only show the welcome section and new UI elements when NOT installed or has no popup */}
          {(!site.installed || !site.has_popup) && (
            <>
              <div className="onboarding-section">
                <div className="welcome-message">
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between', // Better spacing
                    width: '100%' 
                  }}>
                    <h1 style={{ marginLeft: '0px' }}>  
                      Welcome, {capitalizeFirstLetter(user.first_name)}!
                    </h1>
                    <div className="new-popup-container">
                      <NavLink to={editorURL(site, '/new/interstitial')}>
                        <Button
                          color="secondary"
                          variant="contained"
                          className="new-popup-wrap"
                          label={
                            <strong style={{ display: 'flex', alignItems: 'center' }}>
                              <img 
                                src={containerImg} 
                                alt="New Popup" 
                                style={{ 
                                  width: '27.44px', 
                                  height: '27.44px', 
                                  marginRight: '10px' 
                                }} 
                              />
                              New Popup
                            </strong>
                          }
                        />
                      </NavLink>
                    </div>
                  </div>
                </div>
                
                <div 
                  className={`accordion-item ${accordionStates.first ? 'open' : ''}`}
                  onClick={() => toggleAccordion('first')}
                >
                  <div
                    className="accordion-header"
                    style={{ 
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'  // This will push content to ends
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <img
                        src={connecterImg}
                        alt="Connect"
                        style={{ width: '35px', height: '35px' }}
                      />
                      <h2>Connect HelloBar</h2>
                    </div>
                    {!accordionStates.first && (
                      <span style={{ 
                        color: '#777', 
                        fontSize: '14px',
                        marginRight: '15px'
                      }}>
                        ~2 mins
                      </span>
                    )}
                  </div>
                  {accordionStates.first && (
                    <div className="accordion-content">
                      <div className="content-grid">
                        <div className="left-content" style={{ 
                          position: 'relative',
                          minHeight: '10px',
                          padding: '20px 0',
                          whiteSpace: 'nowrap'
                        }}>
                          <h3 style={{ 
                            padding: '17px 26px 17px 8px',
                          }}>
                            Add HelloBar to your site to display popups.
                          </h3>
                          <SiteLink to="/install">
                            <button 
                              className="get-started-btn" 
                              style={{ 
                                width: '118.42px', 
                                height: '32px', 
                                padding: 0, 
                                boxSizing: 'border-box', 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                whiteSpace: 'nowrap', 
                                cursor: 'pointer', 
                                position: 'relative', 
                                left: '9px', 
                                top: '10px'
                              }}
                            >
                              Connect
                            </button>
                          </SiteLink>
                        </div>
                        <div className="right-content">
                          <div className="video-container">
                            <img
                              src={newLayerImg}
                              alt="Install HelloBar"
                              style={{ 
                                maxWidth: '100%',
                                height: 'auto',
                                objectFit: 'contain'
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
               
                <div 
                  className={`accordion-item ${accordionStates.second ? 'open' : ''}`}
                  onClick={() => toggleAccordion('second')}
                >
                  <div
                    className="accordion-header"
                    style={{ 
                      cursor: 'pointer', 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '10px',
                      padding: '20px 16px', // Add padding to increase height
                      minHeight: '80px', 
                      justifyContent: 'space-between'   // Set minimum height
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <img
                        src={inviteImg}
                        alt="Launch"
                        style={{ width: '35px', height: '35px' }}
                      />
                      <h2>Launch your first popup</h2>
                    </div>
                    {!accordionStates.second && (
                      <span style={{ 
                        color: '#777', 
                        fontSize: '14px',
                        marginRight: '15px'
                      }}>
                        ~2 mins
                      </span>
                    )}
                  </div>
                  {accordionStates.second && (
                    <div className="accordion-content">
                      <div className="content-grid">
                        <div className="left-content">
                          <h3>Launch A Popup Now</h3>
                          <p>
                            Our no code popup creator will have you enjoying 83% more
                            conversions in no time.
                          </p>
                          <SiteLink to="/popups/new/interstitial">
                            <button className="get-started-btn">Get started</button>
                          </SiteLink>
                        </div>

                        <div className="right-content">
                          <div className="video-container">
                            <iframe
                              width="560"
                              height="315"
                              src="https://www.youtube.com/embed/8ZTxWGvRd_o?si=UpXjnSHm9yBTIkCs"
                              title="YouTube video player"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              referrerPolicy="strict-origin-when-cross-origin"
                              allowFullScreen
                            ></iframe>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              
              <br />
              <div className="summary-section">
                <h1 className="summary-heading">Summary</h1>
                
                <div className="metrics-container">
                  <div className="metric-box">
                    <div className="metric-title">VIEWS</div>
                    <div 
                      style={{
                        position: 'absolute',
                        left: '20px',
                        top: '40px',
                        width: '16.46px',
                        height: '32px',
                        fontSize: '32px',
                        fontWeight: 'bold',
                        lineHeight: '32px'
                      }}
                    >
                      0
                    </div>
                    <svg className="metric-icon">
                      <circle cx="30" cy="30.5" r="30" fill="rgba(237, 90, 41, 0.1)" />
                      <path 
                        d="M30 18.5C20 18.5 11.26 30.5 11.26 30.5C11.26 30.5 20 42.5 30 42.5C40 42.5 48.74 30.5 48.74 30.5C48.74 30.5 40 18.5 30 18.5Z" 
                        stroke="#ED5A29" 
                        strokeWidth="2" 
                        fill="none"
                      />
                      <circle 
                        cx="30" 
                        cy="30.5" 
                        r="6" 
                        stroke="#ED5A29" 
                        strokeWidth="2" 
                        fill="none"
                      />
                    </svg>
                  </div>
                  <div className="metric-box">
                    <div className="metric-title">EMAILS COLLECTED</div>
                    <div 
                      style={{
                        position: 'absolute',
                        left: '20px',
                        top: '40px',
                        width: '116.46px',
                        height: '32px',
                        fontSize: '32px',
                        fontWeight: 'bold',
                        lineHeight: '32px'
                      }}
                    >
                      0.00%
                    </div>
                    <svg className="metric-icon">
                      <circle cx="30" cy="30.5" r="30" fill="rgba(237, 90, 41, 0.1)" />
                      <image 
                        href={stockImg} 
                        x="15" 
                        y="15" 
                        width="30" 
                        height="30"
                        preserveAspectRatio="xMidYMid meet"
                      />
                    </svg>
                  </div>
                  <div className="metric-box">
                    <div className="metric-title">SOCIAL CONVERSIONS</div>
                    <div 
                      style={{
                        position: 'absolute',
                        left: '20px',
                        top: '40px',
                        width: '16.46px',
                        height: '32px',
                        fontSize: '32px',
                        fontWeight: 'bold',
                        lineHeight: '32px'
                      }}
                    >
                      0
                    </div>
                    <svg className="metric-icon">
                      <circle cx="30" cy="30" r="30" fill="rgba(237, 90, 41, 0.1)" />
                      <image
                        href={circleImg}
                        x="21"
                        y="13"
                        width="16.92"
                        height="16.92"
                        clipPath="circle(50% at center)"
                      />
                      <image
                        href={halfcircleImg}
                        x="15"
                        y="15"
                        width="28.77"
                        height="45"
                        clipPath="circle(50% at center)"
                      />
                    </svg>
                  </div>
                </div>
                
                <div className="graph-container">
                  <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px' }}>
                    {graphs ? (
                      <Charts data={graphs} currentSeries={currentSeries} />
                    ) : (
                      <div>Loading graph data...</div>
                    )}
                  </div>
                </div>
                
                <div className="invite-container">
                  <div className="invite-box">
                    <div className="invite-icon">
                      <img 
                        src={cutcircleImg} 
                        alt="Invite Icon" 
                        style={{ width: '24px', height: '24px' }}
                      />
                    </div>
                    <div className="invite-text">
                      <span>Invite your teammates</span>
                      <span>Get more out of HelloBar by inviting your team for free</span>
                    </div>
                    <InviteUserDialog
                      onChange={() => setReload(!reload)}
                      site={site}
                      limitReached={site?.capabilities?.team_member_limit != null && site?.capabilities?.team_member_count >= site?.capabilities?.team_member_limit}
                      teamMemberLimit={site?.capabilities?.team_member_limit}
                    >
                      <button 
                        className="invite-button" 
                        style={{ 
                          width: '133px',
                          height: '41px',
                          backgroundColor: 'transparent',
                          border: '1px solid #ED5A29',
                          color: '#ED5A29',
                          borderRadius: '4px',
                          fontWeight: 'bold',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                          marginRight: '20px'
                        }}
                      >
                        Invite your team
                      </button>
                    </InviteUserDialog>
                  </div>
                </div>

                {/* Need help? section */}
                <div 
                  style={{ 
                    marginLeft: '7px',
                    marginTop: '30px',
                    marginBottom: '20px',
                    height: '32px',
                    width: '120.92px',
                    display: 'flex',
                    alignItems: 'center',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <h1 
                    style={{ 
                      color: '#23262A',
                      fontWeight: 'bold',
                      fontSize: '24px',
                      lineHeight: '31.2px',
                      letterSpacing: '0%',
                      margin: 0,
                      whiteSpace: 'nowrap'
                    }}
                  >
                    Need help?
                  </h1>
                </div>

                {/* Profile help container */}
                <div className="profile-help-container">
                  <img 
                    src={andrewImg} 
                    alt="Andrew Cattarin" 
                    className="profile-image"
                  />
                  <div className="profile-content">
                    <h3>Andrei</h3>
                    <p>Customer Success Professional at Hello Bar. Please ask me any</p>
                    <p>questions that you may have and I'll answer you asap.</p>
                    <div style={{ marginTop: '12px' }}>
                      <a 
                        href="#" 
                        onClick={(e) => {
                          e.preventDefault();
                          setHelpDialogOpen(true);
                        }}
                        style={{
                          color: '#ED5A29',
                          textDecoration: 'none',
                          fontWeight: 'bold',
                          fontSize: '14px',
                          cursor: 'pointer'
                        }}
                      >
                        Email Me &gt;
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          
          {/* Only show the summary toolbar and charts when installed AND has popup */}
          {site.installed && site.has_popup && (
            <>
              <SummaryToolbar
                site={site}
                rangeChanged={setRange}
                initialRange={1}
              />
              <AppLoader visible={loading} />
              {status === 'error' && <Error error={error} />}
              {status === 'fetched' && (
                <React.Fragment>
                  <div className="chart-wrapper tabs-data">
                    {stastics.map((stat) => (
                      <div
                        className={[
                          'chart-block',
                          stat.chart,
                          currentSeries.includes(stat.type) && 'activated',
                        ].join(' ')}
                        data-chart=""
                        key={stat.type}
                        onClick={updateChart(stat.type)}
                      >
                        <i className={`icon-${stat.icon}`}></i>
                        <p className="chart-overview">
                          {numbers[`${stat.type}_humanized`]}
                          <small>{stat.text}</small>
                        </p>
                      </div>
                    ))}
                  </div>
                  <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px' }}>
                    <Charts data={graphs} currentSeries={currentSeries} />
                  </div>
                </React.Fragment>
              )}
            </>
          )}
        </div>
      )}
    </UserContext.Consumer>
  );
};

export default withTracking(Summary);
